var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Plus",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 18,
    id: "Path-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 9,
    x2: 18,
    y2: 9,
    id: "Path-11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateButton);
export default __webpack_public_path__ + "static/media/create-button.215e4532d63d56c8d7fb7fb6ea4bb2f9.svg";
export { ForwardRef as ReactComponent };